import {
  ApplicationConfig,
  provideZonelessChangeDetection,
  provideAppInitializer,
  inject,
} from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { firstValueFrom } from 'rxjs';

import { routes } from './app.routes';
import { provideKeycloakConfig } from './keycloak.config';
import { authTokenInterceptor } from './core/interceptors/auth-token.interceptor';

registerLocaleData(localeFr);

// Factory function to initialize translations before app startup
export function initializeTranslations(translate: TranslateService): Promise<any> {
  translate.addLangs(['fr', 'en']);

  // Detect browser language
  const browserLang = translate.getBrowserLang();
  const langToUse = browserLang && ['fr', 'en'].includes(browserLang) ? browserLang : 'fr';

  // Return promise that resolves when translations are loaded
  return firstValueFrom(translate.use(langToUse));
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideKeycloakConfig(),
    provideHttpClient(withInterceptors([authTokenInterceptor]), withInterceptorsFromDi()),
    provideTranslateService({
      defaultLanguage: 'fr',
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json',
      }),
    }),
    provideAppInitializer(() => {
      const translate = inject(TranslateService);
      return initializeTranslations(translate);
    }),
  ],
};
